import React from 'react';

interface TextAreaProps {
  name: string;
  label: string;
  value: string;
  onChange: (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>
  ) => void;
  maxCharacters?: number;
  minCharacters?: number;
  required?: boolean;
  placeholder?: string;
  rows?: number;
  error?: string;
}

export const TextArea: React.FC<TextAreaProps> = ({
  name,
  label,
  value,
  onChange,
  maxCharacters,
  minCharacters,
  required = false,
  placeholder,
  rows = 4,
  error,
}) => {
  const safeValue = value || '';
  const currentLength = safeValue.length;
  const showCharacterCount = maxCharacters !== undefined;

  return (
    <div>
      <label
        htmlFor={name}
        className="block text-sm sm:text-base font-medium text-white mb-1.5 sm:mb-2 text-left"
      >
        {label}
        {showCharacterCount && (
          <span className="text-gray-400 text-xs font-normal ml-2">
            ({currentLength}/{maxCharacters}
            {minCharacters ? `, min ${minCharacters}` : ''})
          </span>
        )}
      </label>
      <textarea
        id={name}
        name={name}
        value={safeValue}
        onChange={onChange}
        required={required}
        placeholder={placeholder}
        rows={rows}
        maxLength={maxCharacters}
        className={`w-full p-2 sm:p-2.5 text-sm border rounded sm:rounded-md focus:outline-none sm:focus:ring-2 sm:focus:ring-emerald-500 bg-white text-gray-900 resize-y ${
          error ? 'border-red-500' : 'border-gray-300'
        }`}
      />
      {error && <p className="text-red-500 text-xs sm:text-sm mt-1 text-right">{error}</p>}
    </div>
  );
};

export default TextArea;
